"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var theme_1 = __importDefault(require("../../theme"));
var styles_1 = require("./styles");
function Checkbox(_a) {
    var children = _a.children, checked = _a.checked, custom = _a.custom, _b = _a.color, color = _b === void 0 ? theme_1.default.colorsPalette.blue.default : _b, className = _a.className, style = _a.style, props = __rest(_a, ["children", "checked", "custom", "color", "className", "style"]);
    return (react_1.default.createElement(styles_1.CheckboxContainer, { className: className, style: style === null || style === void 0 ? void 0 : style.root },
        react_1.default.createElement(styles_1.HiddenCheckbox, __assign({ checked: checked }, props)),
        custom ? (children) : (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(styles_1.StyledCheckbox, { checked: checked, disabled: props.disabled, color: color, style: style === null || style === void 0 ? void 0 : style.checkbox },
                react_1.default.createElement(styles_1.CheckboxIcon, { viewBox: "0 0 24 24", style: style === null || style === void 0 ? void 0 : style.icon },
                    react_1.default.createElement("polyline", { points: "20 6 9 17 4 12" }))),
            children && (react_1.default.createElement(styles_1.CheckboxLabel, { style: style === null || style === void 0 ? void 0 : style.label }, children))))));
}
exports.default = Checkbox;
//# sourceMappingURL=index.js.map